export default __webpack_public_path__ + "static/2023 StM Annual School Report-994901dfd88c9668382e1f52e69769a5.pdf";